export default function DS_Linear_Regression_Case() {
  return <div>DS_Linear_Regression_Case Component</div>;
}
